export default __webpack_public_path__ + "static/media/AmandaEdwards.134d5c40.jpg";